import React, { useState } from "react";
import { Box, Button, Modal, TextField, Typography } from "@mui/material";

const CreateUserModal = (props) => {
    const { openModal, handleCloseModal, userName, setUserName, mobileNumber, setMobileNumber, email, setEmail, userLocation, setLocation, startDate, setStartDate, handleUserCreate, endDate, setEndDate, licenseData } = props;
    const [errors, setErrors] = useState({});

    const handleStartDateChange = (e) => {
        const selectedDate = e.target.value;
        setStartDate(new Date(selectedDate).getTime());
        setErrors((prev) => ({ ...prev, startDate: "" }));
    };

    const handleEndDateChange = (e) => {
        const selectedDate = e.target.value;
        setEndDate(new Date(selectedDate).getTime());
        setErrors((prev) => ({ ...prev, endDate: "" }));
    };

    const validateForm = () => {
      const newErrors = {};
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const mobileRegex = /^\d{10}$/;
      if (!userName?.trim()) newErrors.userName = "User name is required";
      if (!mobileNumber?.trim()) {
        newErrors.mobileNumber = "Mobile number is required";
      } else if (!mobileRegex.test(mobileNumber)) {
        newErrors.mobileNumber = "Mobile number must be 10 digits";
      } if (!email?.trim()) {
        newErrors.email = "Email is required";
      } else if (!emailRegex.test(email)) {
        newErrors.email = "Invalid email";
      } if (!startDate) newErrors.startDate = "Start date is required";
      if (startDate && endDate && startDate > endDate)
      newErrors.endDate = "End date cannot be before start date";

      setErrors(newErrors);
      return Object.keys(newErrors).length === 0;
    };

    const handleCreateUser = () => {
      if (validateForm()) {
        handleUserCreate();
      }
    };
  

    return (
    <Modal open={openModal} onClose={handleCloseModal}>
        <Box style={{padding: '32px 0px !important', borderRadius: '4px', position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", background: "white", boxShadow: 24, p: 4, width: 700}}>
          {/* <IconButton aria-label="close" onClick={handleCloseModal} sx={{position: "absolute", top: 8, right: 8, color: (theme) => theme.palette.grey[500]}}>
            <CloseIcon />
          </IconButton> */}
          <Typography id="create-user-modal" variant="h6" component="h2" gutterBottom sx={{fontWeight: '600', borderBottom: 1, borderColor: "divider", padding: '20px 32px'}}>
            Create User
          </Typography>
          <Box sx={{padding: '20px 32px 32px 32px', display: 'flex', flexDirection: 'column', gap: '16px'}}>
            <Box>
              <TextField label="User Name" variant="outlined" required fullWidth value={userName} onChange={(e) => { setUserName(e.target.value); setErrors((prev) => ({ ...prev, userName: "" })); }} error={!!errors.userName} helperText={errors.userName} sx={{ marginBottom: "16px", "& .MuiInputLabel-asterisk": { color: "red" }}}/>
              <TextField label="Mobile Number" variant="outlined" required fullWidth value={mobileNumber} type="number" onChange={(e) => { if (e.target.value.length <= 10) {setMobileNumber(e.target.value); setErrors((prev) => ({ ...prev, mobileNumber: "" })); }}} error={!!errors.mobileNumber} helperText={errors.mobileNumber} sx={{marginBottom: "16px", "& .MuiInputLabel-asterisk": { color: "red" }}}/>
              <TextField label="Email" variant="outlined" required fullWidth value={email} type="email"  onChange={(e) => { setEmail(e.target.value); setErrors((prev) => ({ ...prev, email: "" })); }} error={!!errors.email} helperText={errors.email} sx={{ marginBottom: "16px", "& .MuiInputLabel-asterisk": { color: "red" }}}/>
              <TextField label="Location" variant="outlined" fullWidth value={userLocation} onChange={(e) => { setLocation(e.target.value); setErrors((prev) => ({ ...prev, userLocation: "" })); }} error={!!errors.userLocation} helperText={errors.userLocation} sx={{ marginBottom: "16px", "& .MuiInputLabel-asterisk": { color: "red" }}}/>
              <TextField label="Start Date" variant="outlined" required type="date" fullWidth value={startDate ? new Date(startDate).toISOString().split("T")[0] : ""} onChange={handleStartDateChange} onClick={(e) => e.target.showPicker && e.target.showPicker()} error={!!errors.startDate} helperText={errors.startDate} sx={{ marginBottom: "16px", "& .MuiInputLabel-asterisk": { color: "red" },"& .MuiInputBase-input": { cursor: "pointer" },"& .MuiInputBase-root": { cursor: "pointer" },"& input[type='date']::-webkit-calendar-picker-indicator": { cursor: "pointer" }}} InputLabelProps={{shrink: true}} inputProps={{ min: new Date().toISOString().split("T")[0] }}/>
              <TextField label="End Date" variant="outlined" type="date" fullWidth value={endDate ? new Date(endDate).toISOString().split("T")[0] : ""} onChange={handleEndDateChange} onClick={(e) => e.target.showPicker && e.target.showPicker()} error={!!errors.endDate} helperText={errors.endDate} sx={{ marginBottom: "16px", "& .MuiInputLabel-asterisk": { color: "red" },"& .MuiInputBase-input": { cursor: "pointer" },"& .MuiInputBase-root": { cursor: "pointer" },"& input[type='date']::-webkit-calendar-picker-indicator": { cursor: "pointer" }}} InputLabelProps={{shrink: true}} inputProps={{ min: startDate ? new Date(startDate).toISOString().split("T")[0] : new Date().toISOString().split("T")[0],max: licenseData?.expirationDate ? new Date(licenseData.expirationDate).toISOString().split("T")[0] : undefined}}/>

            </Box>
            <Box sx={{ display: "flex", justifyContent: "center", gap: '16px' }}>
              <Button variant="contained" onClick={handleCreateUser} sx={{textTransform: 'capitalize', fontWeight: '600'}}>
                Create User
              </Button>
              <Button variant="outlined" onClick={handleCloseModal} sx={{textTransform: 'capitalize', fontWeight: '600'}}>
                Cancel
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
  )
}
export default CreateUserModal;